var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86657 1H3.64524C2.95936 1 2.40528 1.70069 2.40528 2.55586L2.3999 13.4441C2.3999 14.2993 2.95398 15 3.63717 15H12.3546C13.0377 15 13.5999 14.2993 13.5999 13.4441V5.66759L9.86657 1ZM3.64524 13.4441V2.55586H9.24524V5.34207C9.24524 5.95172 9.68905 6.44552 10.2378 6.44552H12.3546V13.4469H3.64524V13.4441ZM6.13593 9.2731H9.86657C10.2082 9.2731 10.4879 8.98897 10.4879 8.63586C10.4879 8.28552 10.2109 7.99862 9.86657 7.99862H6.13324C5.79164 7.99862 5.51191 8.28276 5.51191 8.63586C5.51191 8.98621 5.78895 9.2731 6.13324 9.2731H6.13593ZM6.13593 11.8H9.86657C10.2082 11.8 10.4879 11.5159 10.4879 11.1628C10.4879 10.8124 10.2109 10.5255 9.86657 10.5255H6.13324C5.79164 10.5255 5.51191 10.8097 5.51191 11.1628C5.51191 11.5131 5.78895 11.8 6.13324 11.8H6.13593Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboReport);
export default __webpack_public_path__ + "static/media/FBOReport.c5442b278c60ed37ae8b07f38f74db27.svg";
export { ForwardRef as ReactComponent };